module.exports = __webpack_public_path__ + "static/media/SNORTE_MENU-normal.4456f7f6.png";